/**
 * reference: https://wiki.navercorp.com/pages/viewpage.action?pageId=460325086
 */

// https://oss.navercorp.com/Maps/app/blob/master/url_scheme_v2_internal/doc/url_scheme_v2_guide.md#appname
const appName = encodeURIComponent(typeof window === 'undefined' ? '' : window.location.href)

enum OS {
  IN_APP = 'IN_APP',
  IOS = 'IOS',
  ANDROID = 'ANDROID',
}

const SchemePrefix = {
  [OS.IN_APP]: 'inapp://',
  [OS.IOS]: 'http://app.map.naver.com/launchApp/',
  [OS.ANDROID]: 'intent://',
  EXTERNAL_LINK: 'inapp://external_link?url=',
}

const SchemeDefaultParams = {
  [OS.IOS]: '',
  [OS.ANDROID]:
    '#Intent;scheme=nmap;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.nhn.android.nmap;end',
}

enum Type {
  DISSMISS_SELF = 'DISSMISS_SELF',
  HOME = 'HOME',
  BACK = 'BACK',
  CLOSE = 'CLOSE',
}

const Path = {
  [Type.DISSMISS_SELF]: 'dismiss_self',
  [Type.HOME]: 'map',
  [Type.BACK]: 'button_back',
  [Type.CLOSE]: 'button_close',
}

const Query = {
  [Type.HOME]: 'tab=myplace',
  [Type.DISSMISS_SELF]: '',
  [Type.BACK]: '',
  [Type.CLOSE]: '',
}

const getQueryWithAppName = (type: Type) => {
  const query = Query[type]
  if (query && query.length) {
    return `?${query}&appname=${appName}`
  }
  return `?appname=${appName}`
}

function getScheme({ type, inApp = false, os = OS.IN_APP }: { type: Type; inApp?: boolean; os?: OS }): string {
  if (inApp || os === OS.IN_APP) {
    return `${SchemePrefix.IN_APP}${Path[type]}${Query[type]}`
  }
  return `${SchemePrefix[os]}${Path[type]}${getQueryWithAppName(type)}${SchemeDefaultParams[os]}`
}

const nMap = {
  getScheme,
  SchemePrefix,
  Path,
  SchemeDefaultParams,
  appName,
  Type,
  OS,
}

export default nMap
